import { render, staticRenderFns } from "./activity-item.vue?vue&type=template&id=e4fda570&scoped=true&"
import script from "./activity-item.vue?vue&type=script&lang=js&"
export * from "./activity-item.vue?vue&type=script&lang=js&"
import style0 from "./activity-item.vue?vue&type=style&index=0&id=e4fda570&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4fda570",
  null
  
)

export default component.exports